/**
 * Phase types, and the day rate a new phase of each type starts at.
 *
 * The user's own rates are set on the Estimates tab of Settings and saved as
 * `default_phase_rates`. They are never learned from a job: a job's rates are
 * its own. Backend twin: PHASE_TYPES / DEFAULT_PHASE_RATES in
 * backend/models.py.
 */
export const PHASE_TYPES = [
  { value: 'pre', label: 'Pre-Production' },
  { value: 'production', label: 'Production' },
  { value: 'post', label: 'Post-Production' },
  { value: 'travel', label: 'Travel' },
  { value: 'wet_weather', label: 'Wet Weather Hold' },
];

// The rates a new account starts with
export const DEFAULT_PHASE_RATES = {
  pre: 800,
  production: 800,
  post: 800,
  travel: 400,
  wet_weather: 600,
};

/**
 * The day rate a new phase of `type` starts at: the user's saved rate, else
 * the built-in one. A saved 0 is a real rate (an unpaid hold), so it is
 * checked with `??`, never `||`.
 */
export function defaultRateFor(type, rates) {
  return rates?.[type] ?? DEFAULT_PHASE_RATES[type] ?? DEFAULT_PHASE_RATES.production;
}
